import ReactOnRails from 'react-on-rails/client';
import PostsIndex from '../../bundles/public/posts/ror_components/PostsIndex.tsx';

ReactOnRails.register({PostsIndex});